interface Config {
  pagesToShow: (string | RegExp)[];
}

export const downloadMobileAppBannerConfig: Config = {
  pagesToShow: [/^\/models\/[^/]+$/],
};
